/**
 * The coupon call succeeded on the server but the cart could not be read back,
 * so the screen would otherwise announce a state the store does not hold.
 *
 * It lives outside the store module because every consumer test factory-mocks
 * `cart.store`, which would leave the class undefined at the `instanceof`.
 */
export class CartCouponSyncError extends Error {
  constructor() {
    super('The cart could not be read back after the coupon changed.');
    this.name = 'CartCouponSyncError';
  }
}
